const labels = {
  QrCode: {
    'Ref: Page title': 'MyBus',
    'Ref: Hi': 'Hi',
    'Ref: Page content body': 'Wenn Sie an der Ankunft und Abreise abreisen',
  },
};
export default labels;
